export default __webpack_public_path__ + "static/media/parnter-four.e0a6257f.png";